import { useFetcher } from 'react-router';
import { useState } from 'react';

export default function ConfirmIconButton({
  onConfirm,
  children,
  intent,
  action,
  className,
  buttonChildren,
}: {
  onConfirm?: () => void;
  children?: React.ReactNode;
  buttonChildren: React.ReactNode;
  intent: string;
  action: string;
  className?: string;
}) {
  const fetcher = useFetcher();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleConfirm = async () => {
    onConfirm?.();
    // await wait(1);
    setShowConfirm(false);
  };

  if (showConfirm) {
    return (
      <fetcher.Form
        method="post"
        action={action}
        className="flex gap-2"
        onSubmit={() => handleConfirm()}
      >
        {children}

        <button
          className="text-white px-2 py-1 rounded"
          onClick={() => setShowConfirm(false)}
        >
          🚫
        </button>
        <button
          className=" text-white px-2 py-1 rounded"
          type="submit"
          name="intent"
          value={intent}
        >
          ✅
        </button>
      </fetcher.Form>
    );
  }

  return (
    <button onClick={() => setShowConfirm(true)} className={className}>
      {buttonChildren}
    </button>
  );
}
